import React from 'react';
import { Helmet } from 'react-helmet-async';
import FormStyle1 from '../Form/FormStyle1';
import ImageGrid from '../ImageGrid/ImageGrid';

const TestimonialSpainText = () => {
  return (
    <>
      <Helmet>
        <title>Testimonios de Gestación Subrogada - Gestlife</title>
        <meta name="description" content="Testimonios reales de padres que han logrado su sueño de formar una familia a través de la gestación subrogada con Gestlife." />
      </Helmet>
      
      <div style={styles.container}>
      <div style={styles.contentWrapper}>
        {/* Contenido principal a la izquierda */}
        <div style={styles.mainContent}>
          <h1 style={styles.mainHeading}>
            Testimonios
          </h1>

          <div style={styles.textBlock}>
        

            <h4 style={styles.subHeading}>
    Testimonios desde Ucrania
            </h4>

        <h4 style={styles.subHeadingMinor}>
    1. María y Sergio (Madrid) – Ovocitos propios, selección de sexo
        </h4>
     
            <p style={styles.paragraph}>
             “Después de cuatro ciclos de FIV fallidos en Madrid, ya habíamos perdido la esperanza. En Gestlife Ucrania, nos ofrecieron un plan claro, con selección de sexo incluida, algo que en España era impensable. Nuestro pequeño Hugo nació sano hace 7 meses. Fue el final feliz que llevábamos años esperando.”
            </p>

                 <h4 style={styles.subHeadingMinor}>
    2. Cristina y Álvaro (Valencia) – Donación de óvulos
        </h4>
     
            <p style={styles.paragraph}>
            “Mi reserva ovárica era muy baja, y en España solo nos daban largas o nos ofrecían opciones carísimas. En Kiev, Gestlife nos ofreció un proceso con donante de óvulos compatible y humana. Hoy tenemos a nuestra hija Clara en brazos. No hay palabras.”
            </p>
           
                         <h4 style={styles.subHeadingMinor}>
   3. Laura y Pedro (Zaragoza) – Ovocitos propios
        </h4>
     
            <p style={styles.paragraph}>
            “Fuimos a Ucrania como último recurso, tras cinco años de tratamientos en clínicas de reproducción. Nos sorprendió la seriedad, la calidad médica y la calidez humana. No tuvimos que renunciar a nuestros óvulos. A la segunda transferencia, llegó Sofía.”
            </p>
           
                  <h4 style={styles.subHeading}>
    Testimonios desde Georgia
            </h4>

          <h4 style={styles.subHeadingMinor}>
    4. Rocío y Manuel (Málaga) – Donante de óvulos
        </h4>
     
            <p style={styles.paragraph}>
            “Habíamos agotado todas nuestras opciones en España. Nos hablaron de Gestlife en Georgia y fue como encender una luz en mitad del túnel. Nos guiaron paso a paso. Usamos óvulos de donante y el resultado fue nuestro pequeño Gael. ¡Gracias por hacerlo realidad!”
            </p>

                <h4 style={styles.subHeadingMinor}>
   5. Nuria y Luis (Sevilla) – Ovocitos propios y selección de sexo
        </h4>
     
            <p style={styles.paragraph}>
             “Queríamos intentar tener una niña, pero en España no nos dejaban ni hablar del tema. En Tiflis, el equipo de Gestlife fue claro, honesto y profesional. Elegimos una niña y nuestra pequeña Noa llegó con salud y alegría. Fue ético, transparente y profundamente humano.”
            </p>

                           <h4 style={styles.subHeadingMinor}>
  6. Patricia y Rubén (Barcelona) – Donación de óvulos
        </h4>
     
            <p style={styles.paragraph}>
             “Dos abortos, tres transferencias y miles de lágrimas en clínicas españolas. En Georgia encontramos un enfoque distinto: humano y efectivo. El tratamiento con donante fue impecable, y ahora somos papás de Marc. Nos sentimos acompañados de verdad.”
            </p>

                  <h4 style={styles.subHeading}>
    Testimonios desde Albania
            </h4>

    <h4 style={styles.subHeadingMinor}>
 7. Elena y David (Bilbao) – Ovocitos propios, selección de sexo
        </h4>
     
            <p style={styles.paragraph}>
             “Nos hablaron de Albania como una opción seria, y Gestlife nos convenció por su claridad. Usamos nuestros óvulos y pudimos elegir tener un niño, como siempre habíamos deseado. Joel nació en Barcelona y no podemos estar más agradecidos.”
            </p>
                <h4 style={styles.subHeadingMinor}>
 8. Silvia y Marcos (A Coruña) – Donante de óvulos
        </h4>
     
            <p style={styles.paragraph}>
             “Después de nueve años y seis intentos fallidos en España, perdimos toda ilusión. En Albania, Gestlife no solo nos devolvió la esperanza: nos la cumplió. Óvulos de donante, acompañamiento emocional, y hoy dormimos con la pequeña Vega en nuestra casa.”
            </p>
                <h4 style={styles.subHeadingMinor}>
  9. Isabel y Tomás (Murcia) – Transplante pronuclear
        </h4>
     
            <p style={styles.paragraph}>
             “Mi diagnóstico genético era complejo. Gestlife nos propuso un protocolo experimental: transplante pronuclear. En España nadie nos lo mencionó jamás. El embrión fue sano, la gestación impecable, y Alba llegó a nuestras vidas con una historia única. Increíble y real.”
            </p>
            

           
          </div>
        </div>

        {/* Formulario a la derecha, sin envoltorio extra ni sticky
        <div style={styles.formColumn}>
          <FormStyle1 />
        </div> */}
      </div>
    </div>
    </>
  );
};

export default TestimonialSpainText;

// --- Estilos para la versión de escritorio ---
const styles = {
  container: {
    backgroundColor: 'white',
    padding: '2rem',
    paddingTop: '3rem',
    paddingBottom: '3rem',
    fontFamily: 'Arial, sans-serif', 
    paddingLeft: '4rem',
    paddingRight: '4rem',
  },
  contentWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr', // Por defecto, una columna para móviles
    gap: '4rem', 
    maxWidth: '1200px', 
    margin: '0 auto', 
    // La media query para desktop se simula con JS debajo
    // Idealmente, esto iría en CSS externo o con una librería CSS-in-JS.
    '@media (min-width: 1024px)': { 
      gridTemplateColumns: '2fr 1fr', 
    },
  },
  mainContent: {
    marginBottom: '2rem', // Mantener espacio para móviles/tablets
    '@media (min-width: 1024px)': {
      marginBottom: '0', // Eliminar el margen si hay dos columnas
    },
  },
  mainHeading: {
    fontSize: '2.8rem', 
    fontWeight: 'bold',
    color: '#ec4899', 
    lineHeight: '1.2',
    marginBottom: '1.5rem', 
  },
  subHeading: {
    fontSize: '1.8rem', 
    fontWeight: '700', 
    color: '#f472b6', 
    marginTop: '2.5rem', 
    marginBottom: '1.5rem', 
    borderBottom: '2px solid #f9a8d4', 
    paddingBottom: '0.5rem',
  },
  subHeadingMinor: { 
    fontSize: '1.3rem', 
    fontWeight: '600', 
    color: '#f472b6', 
    marginTop: '2rem',
    marginBottom: '1rem',
  },
  textBlock: {
    color: '#4b5563',
    lineHeight: '1.7', 
    fontSize: '1.05rem', 
    marginTop: '1.5rem',
  },
  paragraph: {
    marginBottom: '1rem', 
  },
  highlightedParagraph: {
    fontWeight: '700', 
    color: '#1f2937', 
    textDecoration: 'underline',
    textDecorationColor: '#f9a8d4', 
    marginBottom: '1.2rem', 
    fontSize: '1.1rem', 
  },
  formColumn: {
    // Ya no necesita position: 'relative' si el formulario no es sticky
    // El formulario FormStyle1 controlará sus propios estilos internos
  },
  // Eliminamos el objeto stickyForm, ya no es necesario
};
